import React, { FunctionComponent } from 'react';
import Headline, { IHeadline } from 'bit/shared/headline';
import { IHeading } from '@/types';
import * as s from './headline-proxy.module.scss';

interface IHeadlineProxy extends IHeadline {
  centerTablet?: boolean;
  underline?: boolean;
  center?: boolean;
  className?: string;
  headlineClassName?: string;
  underlineClass?: string;
  centerMobile?: boolean;
  white?: boolean;
  html?: string | null;
  hero5?: boolean;
  newStyle?: boolean;
  newHeading?: IHeading | null;
}

const HeadlineProxy: FunctionComponent<IHeadlineProxy> = (props) => {
  const { newHeading, hero5, centerTablet, centerMobile, center, underline, className, heroHeadline, newStyle } = props;
  const centerTabletClass = centerTablet ? s.centerTablet : '';
  const centerMobileClass = centerMobile ? s.centerMobile : '';
  const centerClass = center ? s.center : '';
  const underlineClass = underline ? s.underline : '';
  const centerUnderlineClass = center ? s.centerUnderline : '';
  const centerUnderlineMobileClass = centerMobile ? s.centerUnderlineMobile : '';
  const newStyleClass = newStyle ? s.newStyle : '';
  const proxyClasses = `${centerTabletClass} ${centerMobileClass} ${centerClass} ${className} ${newStyleClass}`;

  if (hero5) {
    return (
      <div className={`${centerClass} ${className || ''} ${centerMobileClass}`}>
        <Headline {...props} newHeading={newHeading} styles={s} className={proxyClasses} heroHeadline={heroHeadline} />
        <div className={`${underlineClass || ''} ${centerUnderlineClass} ${centerUnderlineMobileClass}`} />
      </div>
    );
  } else {
    return (
      <Headline {...props} newHeading={newHeading} styles={s} className={proxyClasses} heroHeadline={heroHeadline} />
    );
  }
};

export default HeadlineProxy;
